(() => {
  const preview = key => {
    const one = (label, price) => ({ options: ['Formato'], variants: [{ options: [label], price, available: true }] });
    if (key === 'lomito') return { options: ['Formato'], variants: [{ options: ['Loncheado 100 g'], price: 800, available: true }, { options: ['Pieza entera aprox. 450 g'], price: 2950, available: true }] };
    if (key === 'cecina') return one('100 g', 690);
    if (key === 'papada') return one('50 g', 245);
    if (key === 'palitos') return one('12 unidades', 250);
    if (key === 'paleta') return one('150 g', 2250);
    const types = ['Cebo de Campo · zona de Jabugo', 'Bellota 100% Ibérico · zona de Jabugo', '5J · Bellota 100% Ibérico · zona de Jabugo'];
    return { options: ['Jamón', 'Parte', 'Formato'], variants: types.flatMap((type, i) => ['Maza', 'Babilla'].flatMap(part => ['100 g', '150 g'].map((size, n) => ({ options: [type, part, size], price: [1200, 2000, 2500][i] * (n ? 1.5 : 1), available: true })))) };
  };
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const source = JSON.parse(root.querySelector('[data-cp-data]').textContent);
    const data = source.actual ? source : { ...source, ...preview(root.dataset.key) };
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: data.currency || 'EUR' }).format(cents / 100);
    const variants = data.variants || [];
    const query = new URLSearchParams(location.search);
    const initial = variants.find(v => String(v.id) === query.get('variant')) || variants.find(v => v.available) || variants[0];
    let selected = initial ? [...initial.options] : [];
    const holder = root.querySelector('[data-cp-options]');
    const form = root.querySelector('[data-cp-form]');
    const submit = root.querySelector('[data-cp-submit]');
    const id = root.querySelector('[data-cp-id]');
    const status = root.querySelector('[data-cp-status]');
    const qty = form.elements.quantity;
    const groups = data.options.map((name, index) => {
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      const singleFormat = (data.options.length === 1 || /formato/i.test(name)) && new Set(variants.map(v => v.options[index])).size === 1;
      legend.textContent = singleFormat ? 'Único formato' : `${data.options.length > 1 ? `${index + 1}. ` : ''}Elige ${name.toLowerCase()}`;
      fieldset.append(legend);
      const choices = document.createElement('div'); choices.className = 'vj-cp__choices'; fieldset.append(choices);
      const radios = [...new Set(variants.map(v => v.options[index]))].map(value => {
        const label = document.createElement('label'); label.className = 'vj-cp__choice';
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = `option-${index}`; radio.value = value;
        const text = document.createElement('span'); text.textContent = value;
        label.append(radio, text); choices.append(label);
        radio.addEventListener('change', () => { selected[index] = value; update(index); });
        return radio;
      });
      holder.append(fieldset); return radios;
    });
    function update(changed = -1) {
      groups.forEach((radios, index) => {
        const possible = value => variants.some(v => v.options[index] === value && selected.slice(0, index).every((s, n) => v.options[n] === s));
        if (index > changed && !possible(selected[index])) selected[index] = radios.find(r => possible(r.value))?.value;
        radios.forEach(r => { r.disabled = !possible(r.value); r.checked = r.value === selected[index]; });
      });
      const variant = variants.find(v => selected.every((s, n) => v.options[n] === s));
      const priced = variant && variant.price > 0;
      const ready = root.dataset.ready === 'true' && data.actual && variant?.id && variant.available && priced;
      root.querySelector('[data-cp-price]').textContent = priced ? money(variant.price) : 'Precio por confirmar';
      root.querySelector('[data-cp-selection]').textContent = selected.join(' · ');
      submit.disabled = !ready; id.disabled = !ready; id.value = ready ? variant.id : '';
      submit.textContent = root.dataset.ready === 'true' && !variant?.available ? 'Agotado' : `Añadir al carrito${priced ? ` · ${money(variant.price)}` : ''}`;
      status.textContent = ready ? 'Gastos de envío calculados al finalizar la compra.' : '';
      status.hidden = !ready;
      if (data.actual && variant?.id) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    const clamp = () => { qty.value = Math.max(1, Math.min(99, parseInt(qty.value, 10) || 1)); };
    root.querySelector('[data-cp-minus]').addEventListener('click', () => { qty.value = Number(qty.value) - 1; clamp(); });
    root.querySelector('[data-cp-plus]').addEventListener('click', () => { qty.value = Number(qty.value) + 1; clamp(); });
    qty.addEventListener('change', clamp);
    form.addEventListener('submit', event => { clamp(); if (submit.disabled || !id.value || id.disabled) event.preventDefault(); });
    update();
  }
  function boot() { document.querySelectorAll('[data-catalog-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (!window.vjCatalogEditorBound) { document.addEventListener('shopify:section:load', boot); window.vjCatalogEditorBound = true; }
})();
